export default __webpack_public_path__ + "static/media/9001_2015.f8d85a01.pdf";